var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.735 3.19897V6.19297H5.265V3.19897V1.99187L4.41145 2.84542L-0.353553 7.61042L-0.707144 7.96401L-0.353516 8.31756L4.41148 13.0816L5.265 13.9349V12.728V9.73397H18.735V12.729V13.9361L19.5886 13.0825L24.3536 8.31753L24.7071 7.96397L24.3536 7.61042L19.5886 2.84542L18.735 1.99187V3.19897Z",
    fill: "#4824C1",
    stroke: "#4824C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.03401282286a11b0624d48ce565f34b0.svg";
export { ForwardRef as ReactComponent };